export const countryProfile = {
  countrySummary: {
    text: "Resumen del país",
    keyContacts: "Contactos clave",
    resources: "Recursos",
  },
  exportCountryDataButton: "EXPORTANCIÓN DE DATOS DEL PAÍS",
  downloadScorecard: "DESCARGAR CUADRO DE MANDO",
  overallDigitalHealthPhase: "Fase General De Salud Digital",
  overallDigitalHealthPhaseDescription:
    "La puntuación global es una media de las puntuaciones de los indicadores del GDHM",
  benchmark: {
    text: "PUNTO DE REFERENCIA",
    textWithData: "PUNTO DE REFERENCIA: {data}",
    benchmarkValues: {
      globalAverage: "Promedio Global",
      atAvg: "EN PROMEDIO",
      belowAvg: "BAJO PROMEDIO",
      aboveAvg: "ARRIBA PROMEDIO",
    },
    benchmarkDescription:
      "Compare su puntaje general con el Promedio Global u otros países de la fase",
    benchmarkNoCountryForSelectedPhase:
      "Ningún país en la fase seleccionada para comparar",
    serverErrorDescription:
      "No se pueden cargar los datos de referencia. Por favor, inténtalo después de un tiempo.",
    average: "Promedio",
  },
  indicator: "Indicador",
  score: "PUNTUACIÓN",
  govtData: "Aprobado por el gobierno",
  nonGovtData: "Aprobación pendiente del gobierno",
  selectYear: "Seleccionar año",
  selectYearDescription:
    "Para ver los datos de un año específico, seleccione el año deseado",
  phaseOverview: " Resumen de fases",
  countryProgressOverTime: "Progreso del país a lo largo del tiempo",
  countryProgressLineChart: {
    indicatorGroupingDescription: "Seleccione un indicador",
    globalAverage: "Promedio global",
  },
  compareTo: "Comparar con",
  region: "Región",
};
